import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/sections.css";
import { ArrowRight, Discord, Instagram, Users } from "../components/Icons";

const CommunityCTA = () => (
  <section className="community-cta" aria-labelledby="community-cta-title">
    <div className="container">
      <div className="community-card" data-reveal>
        <span className="community-icon" aria-hidden="true">
          <Users />
        </span>
        <h2 id="community-cta-title">Be first to hear when a campaign opens</h2>
        <p>
          Shares are limited and close once they fill. Our community channels are where new
          campaigns, farm updates and delivery days are announced first.
        </p>

        <div className="community-actions">
          <a
            className="btn btn--light"
            href="https://discord.gg/X47Vt45XWh"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Discord />
            Join the Discord
          </a>
          <a
            className="btn btn--outline-light"
            href="https://www.instagram.com/farmerboaz?igsh=MXNrdGMwbjdqcW5lNQ=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram />
            Follow on Instagram
          </a>
        </div>

        <Link to="/order-now" className="community-link">
          Or browse what is open right now
          <ArrowRight />
        </Link>
      </div>
    </div>
  </section>
);

export default CommunityCTA;
